import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import classnames from "classnames";
import { isEmpty } from 'lodash'
import { trackValues } from '../../tracker';
import { trackSiteId, urls } from '../../config';

import { jsonFetch } from '../../utils/fetch';

import { languageTestFetchIfNeeded, languageTestSet } from '../../store/languageTest/actions';
import { profileFetchIfNeeded, profileFetch } from '../../store/profile/actions';
import { usePrevious } from '../../hooks';

import Loader from '../shared/Loader'
import Button from '../shared/Button/index';
import baseStyles from 'custom/base.styl';
import Timer from './Timer';
import Radiobutton from '../shared/Radiobutton/index';


const PageLanguageTest = () => {
  const profile = useSelector(state => state.profile.data.user);
  const profileNowTime = useSelector(state => state.profile.data.now);
  const langTest = useSelector(state => state.languageTest);
  const loadingProfile = useSelector(state => state.profile.isFetching);
  const loadingTest = useSelector(state => state.languageTest.isFetching);
  const subjStatus = langTest.status;
  const isSubmiting = langTest.isSubmiting;

  const prevStatus = usePrevious(subjStatus || 'testing');
  const [endTime, setEndTime] = useState(null);

  const [stateAnswer, setAnswer] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (subjStatus !== prevStatus) {
      setTimeout(() => {
        dispatch(profileFetch())
      }, 2000);
    }
  }, [subjStatus]);

  useEffect(() => {
    if (!profile) {
      dispatch(profileFetchIfNeeded())
    }
    if (profile && profile.profile.application_overview_timestamp) {
      let startTime = moment.unix(profile.profile.application_overview_timestamp)
      let nowTime = moment.unix(profileNowTime)
      if (!startTime) { startTime = nowTime }
      const diff = 15 * 60 * 1000 - nowTime.diff(startTime)
      const endTime = moment().add(diff, 'milliseconds').toISOString()
      setEndTime(endTime);
    }
  }, [profile]);

  useEffect(() => {
    if (!langTest.answer && !loadingTest) {
      dispatch(languageTestFetchIfNeeded())
    }
  }, [langTest]);

  const timeout = () => {
    const data = {
      answer_id: langTest.answer.answer_id,
      answer: -1,
    }
    trackValues('language_test_end', true, {
      context: { userId: profile.id, site_id: trackSiteId, version: profile.scenario_version, is_experied: true },
    });
    dispatch(languageTestSet(data))
  }

  const _handleOnClickNext = (e) => {
    const data = {
      answer_id: langTest.answer.answer_id,
      answer: stateAnswer,
    }

    dispatch(languageTestSet(data))
    setAnswer(null)
    dispatch(profileFetch())
  }

  const _handleOnChange = (e) => {
    setAnswer(e.target.value)
  }

  const onCopyHandler = (e) => {
    // if (process.env.NODE_ENV === 'production')
    // if (process.env.NODE_ENV === 'development')

    const answerId = langTest.answer.answer_id
    const question = langTest.answer.data.question
    const selectedText = document.getSelection().toString();

    if (selectedText.length > 0) {
      const data = {
        info: { answer_id: answerId, answer: question },
        stage: profile.stage,
        text: selectedText,
      }
      jsonFetch(`${urls.eventLogs}`, data, { method: 'POST' });
    }
  }

  if (loadingProfile || loadingTest) {
    return <Loader absolute />
  }


  if (isEmpty(langTest.answer)) return null;

  const { answers, progress } = langTest

  return (
    <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.testing)} onCopy={onCopyHandler}>
      {progress &&
        <div className={baseStyles.test_header}>{progress.complete + 1}/{progress.total}</div>
      }
      <h2 className={baseStyles.test_title} >{langTest.answer.data.question}</h2>
      {answers &&
        <div className={baseStyles.test_body}>
          {(answers || []).map((number) =>
            <div className={baseStyles.radio_wrap} key={number}>
              <Radiobutton
                checked={stateAnswer === number.toString()}
                onChange={(e) => _handleOnChange(e)}
                type="radio"
                id={langTest.answer.answer_id}
                name={langTest.answer.answer_id}
                value={number}
              >
                {langTest.answer.data[`answer${number}`]}
              </Radiobutton>
            </div>
          )}
        </div>
      }

      <Button onClick={() => _handleOnClickNext()} disabled={isSubmiting || !stateAnswer}>Next</Button>

      {endTime &&
        <div className={baseStyles.test_footer}>Time left: <Timer endTime={endTime} submitTest={() => timeout()} /></div>
      }
    </div>
  )
}

export default PageLanguageTest;



// WEBPACK FOOTER //
// ./src/components/LanguageTest/PageLanguageTest.js